import { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

import "./section2.css";
import ImagemFundo from "../../assets/images/fundosofa.png";

function Section2() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
    });
  }, []);

  return (
    <section className="container-fluid mt-5 px-2 px-md-4 px-xl-5 section2">
      <div className="section2-wrapper">
        <div className="text-center mb-4">
          <h2 className="titulos-secoes" data-aos="fade-up">
            O Escritório
          </h2>
        </div>

        {/* Card Principal Institucional */}
        <div
          className="card border-0 rounded-3 shadow-lg overflow-hidden card-escritorio-destaque mb-5 position-relative"
          data-aos="fade-up"
        >
          <img
            src={ImagemFundo}
            className="card-img rounded-3 brilho-40 fundo-escritorio-personalizado"
            alt="Ambiente profissional e acolhedor do escritório Antonio Saldanha Advocacia"
            loading="lazy"
            width="900"
            height="500"
          />
          <div className="card-img-overlay d-flex flex-column align-items-center justify-content-center text-center p-3 p-md-5 overlay-escritorio">
            <p className="text-white texto-escritorio-personalizado mb-4">
              Antonio Saldanha Advocacia é um escritório em constante ascensão e
              inovação, que combina técnica apurada, agilidade e visão
              estratégica para oferecer uma advocacia moderna e eficiente. Com
              postura ética, comunicação clara e atenção total a cada detalhe,
              atuamos com seriedade e profundidade para entregar segurança e
              tranquilidade jurídica aos nossos clientes. Buscamos construir
              confiança, oferecer clareza e atuar como um parceiro presente em
              todas as etapas do caminho.
            </p>
            <Link to="/o-escritorio" className="btn botao-dourado shadow">
              Saiba mais sobre o escritório
            </Link>
          </div>
        </div>

        {/* Grid de Diferenciais Institucionais */}
        <div className="mt-5">
          <div className="text-center mb-4" data-aos="fade-up">
            <h3 className="subtitulo-diferenciais text-uppercase fw-bold fs-4">
              Diferenciais Institucionais
            </h3>
          </div>

          <div className="row g-4">
            <div
              className="col-12 col-sm-6 col-lg-3"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="card card-diferencial h-100 border-0 p-4 text-center rounded-3 shadow-sm">
                <div className="icone-diferencial mb-3">
                  <svg
                    width="36"
                    height="36"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                    className="text-dourado"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                    />
                  </svg>
                </div>
                <h4 className="fs-5 fw-semibold mb-2">
                  Atendimento Personalizado
                </h4>
                <p className="text-muted small mb-0">
                  Acompanhamento dedicado e escuta atenta para compreender em
                  profundidade as particularidades e metas de cada cliente.
                </p>
              </div>
            </div>

            <div
              className="col-12 col-sm-6 col-lg-3"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <div className="card card-diferencial h-100 border-0 p-4 text-center rounded-3 shadow-sm">
                <div className="icone-diferencial mb-3">
                  <svg
                    width="36"
                    height="36"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                    className="text-dourado"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                    />
                  </svg>
                </div>
                <h4 className="fs-5 fw-semibold mb-2">Visão Estratégica</h4>
                <p className="text-muted small mb-0">
                  Combinação de rigorosa técnica jurídica com inteligência
                  preventiva para buscar os melhores resultados.
                </p>
              </div>
            </div>

            <div
              className="col-12 col-sm-6 col-lg-3"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              <div className="card card-diferencial h-100 border-0 p-4 text-center rounded-3 shadow-sm">
                <div className="icone-diferencial mb-3">
                  <svg
                    width="36"
                    height="36"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                    className="text-dourado"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <h4 className="fs-5 fw-semibold mb-2">Ética e Transparência</h4>
                <p className="text-muted small mb-0">
                  Comunicação honesta, direta e sem linguagem hermética em todas
                  as fases da sua demanda jurídica.
                </p>
              </div>
            </div>

            <div
              className="col-12 col-sm-6 col-lg-3"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              <div className="card card-diferencial h-100 border-0 p-4 text-center rounded-3 shadow-sm">
                <div className="icone-diferencial mb-3">
                  <svg
                    width="36"
                    height="36"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                    className="text-dourado"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 18h.01M8 2h8a2 2 0 012 2v16a2 2 0 01-2 2H8a2 2 0 01-2-2V4a2 2 0 012-2z"
                    />
                  </svg>
                </div>
                <h4 className="fs-5 fw-semibold mb-2">
                  Estrutura Digital Nacional
                </h4>
                <p className="text-muted small mb-0">
                  Agilidade no atendimento presencial ou online para representar
                  seus interesses em qualquer estado do país.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Section2;
